import { useQuery } from '@tanstack/react-query'
import { useNetwork } from '@/contexts/NetworkContext'
import { AuthService } from '@/services/core/auth'
import { ProductFeedApi } from '@/services/productFeed/productFeedApi'

/**
 * Whether the current network imports a retail product feed with products in
 * it — what decides if retail products are offered at all.
 */
export function useHasRetailProducts(enabled = true): boolean {
  const { currentNetwork } = useNetwork()
  const tagId = currentNetwork?.tagId
  const { data = false } = useQuery({
    queryKey: ['productfeed', 'hasProducts', tagId],
    queryFn: () => ProductFeedApi.hasProducts(),
    enabled: enabled && !!tagId && AuthService.isAuthenticated(),
    staleTime: 30 * 60 * 1000,
  })
  return data
}
